var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "data-label" }, [
      _c("div", { staticClass: "ellipsis" }, [
        _vm._v(_vm._s(_vm.forceLabel ? _vm.forceLabel : _vm.label))
      ]),
      _vm._v(" "),
      _vm.useFavorite
        ? _c("i", {
            class: [
              "blue ml-2 fs-2 cpointer data-label-icon-toggle",
              _vm.isFavoriteClass
            ],
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggleFavorite($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.canRemoveFavorite
        ? _c("i", {
            staticClass: "icon-close primary-50 ml-2 fs-2 cpointer",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggleFavorite($event)
              }
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "span",
      { class: ["data-value copy-element", _vm.canRemoveFavoriteClass] },
      [
        _c(
          "a",
          {
            staticClass: "black-link semibold",
            attrs: { href: _vm.formatHref(_vm.value), target: "_blank" }
          },
          [_vm._v("\n            " + _vm._s(_vm.value) + "\n        ")]
        ),
        _vm._v(" "),
        _vm.value
          ? _c("SaasClipboard", { attrs: { data: _vm.value } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }